import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.667 3.333h-.854l-.213-.666a2 2 0 0 0-1.893-1.334H6.293A2 2 0 0 0 4.4 2.7l-.213.667h-.854a2 2 0 0 0-2 2V10.7a2 2 0 0 0 2 2h9.334a2 2 0 0 0 2-2V5.367a2 2 0 0 0-2-2.034m.666 7.334a.667.667 0 0 1-.666.666H3.333a.667.667 0 0 1-.666-.666V5.333a.667.667 0 0 1 .666-.666h1.334a.67.67 0 0 0 .666-.454l.36-1.093a.67.67 0 0 1 .634-.453H9.74a.67.67 0 0 1 .633.453l.36 1.093a.67.67 0 0 0 .6.454h1.334a.667.667 0 0 1 .666.666zM8 4.667A2.667 2.667 0 1 0 8 10a2.667 2.667 0 0 0 0-5.333m0 4A1.333 1.333 0 1 1 8 6a1.333 1.333 0 0 1 0 2.667"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })